import React from 'react';
import { extendesClassname, getColClass } from '../utils';
import { GridColType } from 'type.global';

type FieldRadioProps = {
    label: React.ReactNode;
    classNameLabel?: string;
    classNameField?: string;
    isInvalid?: boolean;
    xs?: GridColType;
    sm?: GridColType;
    md?: GridColType;
    lg?: GridColType;
    xl?: GridColType;
    xxl?: GridColType;
    xxxl?: GridColType;
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

function FieldRadio({
    label = '',
    classNameLabel = '',
    classNameField = '',
    isInvalid = false,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
    xxxl,
    children,
    ...props
}: FieldRadioProps) {
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        const setInvalid = () => {
            const _isInvalidClassname = inputRef.current?.classList?.contains('is-invalid');

            if (isInvalid) {
                inputRef.current?.setCustomValidity('Invalid field.');

                if (!_isInvalidClassname) inputRef.current?.classList.add('is-invalid');
            } else if (_isInvalidClassname) {
                inputRef.current?.classList.remove('is-invalid');
            }
        };

        setInvalid();

        return () => inputRef.current?.setCustomValidity('');
    }, [isInvalid]);

    return (
        <div {...extendesClassname(['exp-form-check', ...getColClass({ xs, sm, md, lg, xl, xxl, xxxl }), classNameField])}>
            <input
                {...props}
                {...extendesClassname(['exp-form-check-input', props.className ?? ''])}
                // onChange={onChange}
                ref={inputRef}
                type='radio'
                id={props.id ? props.id : props.name}
            />
            <label htmlFor={props.id ? props.id : props.name} {...extendesClassname([classNameLabel])}>
                {label}
            </label>
            {children}
        </div>
    );
}

export default FieldRadio;
